import React, { SFC } from 'react';
import classNames from 'classnames';

export interface SelectOption {
  value: string;
  text: string;
}

export interface SelectProps {
  id: string;
  title: string;
  options: SelectOption[];
  value?: string;
  hasError?: boolean;
  errorMessage?: string;
  showRequiredMark?: boolean;
  onBlur?: React.FocusEventHandler<HTMLSelectElement>;
  onChange?: (value: string) => void;
}

export type SelectComponent = SFC<SelectProps>;

const renderOptions = (options: SelectOption[]): JSX.Element[] =>
  options.map(item => (
    <option key={item.value} value={item.value}>
      {item.text}
    </option>
  ));

export const Select: SelectComponent = ({
  id,
  title,
  value,
  options,
  hasError,
  errorMessage,
  showRequiredMark,
  onBlur,
  onChange = () => {},
}) => {
  const changeHandler: React.ChangeEventHandler<HTMLSelectElement> = e => {
    onChange(e.target.value);
  };
  return (
    <div className="input-group">
      <select
        id={id}
        className={classNames(
          'select-input',
          'alt-input',
          { error: hasError },
          value || options[0].text ? 'is-filled' : '',
        )}
        onBlur={onBlur}
        onChange={changeHandler}
        value={value}
      >
        {renderOptions(options)}
      </select>
      <label htmlFor={id}>
        {title} {showRequiredMark ? ' *' : ''}
      </label>
      {hasError && errorMessage ? <span className="mx-error-message">{errorMessage}</span> : null}
    </div>
  );
};
